import { render, staticRenderFns } from "./GridStockWatch.vue?vue&type=template&id=3a85f7b0&"
import script from "./GridStockWatch.vue?vue&type=script&lang=js&"
export * from "./GridStockWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports